var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-edit-sequence/home-banner-edit-sequence.html';
var html = "<section class=home-banner-edit-sequence> <form name=homeBannerEditSequenceForm ng-submit=$ctrl.onSubmit()> <div class=\"col-md-12 edit-sequence\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 inner-page-title\"> <h1 class=text-capitalize>edit sequence</h1> </div> <div class=clear></div> <content-sequence list=$ctrl.details></content-sequence> <div class=clear></div> <form-buttons disable-buttons=disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home-banner/home-banner-edit-sequence/home-banner-edit-sequence.html
// module id = 770
// module chunks = 0